import * as React from 'react';
import { Suspense } from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import { AccessTokenJsConstantsCrossModel } from "./models/index";
import IndberetResultat, { LeagueMatchContextMode } from './pages/DBF/Admin/Holdkamp/IndberetResultat';
import store from './store';
import { userActions } from './common/users';
import { ability, updateUserPermissions } from "./common/users/userAbility";
import { parseQueryString } from './api';
import { AbilityContext } from './common/users/userCan';
import bplayTheme from './components/ui/muiTheme';
//const IndberetResultat = lazy(() => import('./pages/DBF/Admin/Holdkamp/IndberetResultat'));
class App extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        const clubId = parseQueryString('clubid');
        updateUserPermissions(Number(clubId));
    }
    render() {
        return (React.createElement(Provider, { store: store },
            React.createElement(AbilityContext.Provider, { value: ability },
                React.createElement(ThemeProvider, { theme: bplayTheme },
                    React.createElement(Suspense, { fallback: React.createElement("div", null, "Indl\u00E6ser...") },
                        React.createElement(Router, null,
                            React.createElement(Switch, null,
                                React.createElement(Redirect, { exact: true, from: "/", to: "/DBF/Admin/Holdkamp/IndberetResultat/Kamp" }),
                                React.createElement(Route, { exact: true, path: "/DBF/Admin/Holdkamp/IndberetResultat/Kamp", render: (props) => React.createElement(IndberetResultat, Object.assign({}, props, { ContextMode: LeagueMatchContextMode.AdminMode })) }),
                                React.createElement(Redirect, { exact: true, from: "/", to: "/DBF/Klub/IndberetResultat/Kamp" }),
                                React.createElement(Route, { exact: true, path: "/DBF/Klub/IndberetResultat/Kamp", render: (props) => React.createElement(IndberetResultat, Object.assign({}, props, { ContextMode: LeagueMatchContextMode.ClubMode })) }))))))));
    }
}
const loadLocalDevelopmentEnvironment = () => {
    window.localStorage.setItem(AccessTokenJsConstantsCrossModel.webApiUrl, 'http://localhost:4321');
    var formData = new FormData();
    formData.append("client_id", "bplayV2");
    formData.append("client_secret", "badminton2020");
    //formData.append("grant_type", "client_credentials");
    formData.append("grant_type", "password");
    formData.append("username", "mojo@badminton.dk");
    formData.append("password", "4F37C061F1854F9682F543FECB5EE9D652C803235970202DE97C6E40C8361766");
    //formData.append("username", "carsten.norgaard@hotmail.com");
    //formData.append("password", "ABBBB819143AE4A72A745E65F98FCCC0453A534A5882ED7B6285DF5201DA7C9E");
    formData.append("scope", "apiV1");
    fetch("http://localhost:4322/connect/token", {
        method: 'POST',
        body: formData
    }).then((response) => response.json()).then((data) => {
        let bplayV2 = { [AccessTokenJsConstantsCrossModel.accessTokenKey]: data.access_token, [AccessTokenJsConstantsCrossModel.tokenTypeKey]: data.token_type, [AccessTokenJsConstantsCrossModel.userRolesKey]: [], [AccessTokenJsConstantsCrossModel.unionClubIdKey]: 978 };
        window.localStorage.setItem(AccessTokenJsConstantsCrossModel.localStorageVariableName, JSON.stringify(bplayV2));
        //const action = userActions.getUserRoles(7, '0A2E28FFD7BACB200F2EDE6FA3CE2EA4F302DEAFC672F986F5BD0CA811FBFCF9');
        const action = userActions.getUserRoles(53888, '4F37C061F1854F9682F543FECB5EE9D652C803235970202DE97C6E40C8361766');
        store.dispatch((action));
        let currentState;
        store.subscribe(() => {
            const prevAuth = currentState;
            currentState = store.getState().users;
            if (prevAuth !== currentState && !currentState.loggedInUser.isLoading) {
                const userRoles = currentState.loggedInUser.user.userRoles;
                const result = Object.keys(userRoles).map(key => { return { [AccessTokenJsConstantsCrossModel.clubIdKey]: Number(key), [AccessTokenJsConstantsCrossModel.roleMaskKey]: userRoles[key].roleMask, [AccessTokenJsConstantsCrossModel.isSystemRoleKey]: userRoles[key].isSystemRole }; });
                bplayV2[AccessTokenJsConstantsCrossModel.userRolesKey] = result;
                window.localStorage.setItem(AccessTokenJsConstantsCrossModel.localStorageVariableName, JSON.stringify(bplayV2));
            }
            if (!currentState.loggedInUser.isLoading) {
                renderComponentsConditionally();
            }
        });
    });
};
const loadServerEnvironment = () => {
    const sys = window.Sys;
    if (sys && sys.WebForms && sys.WebForms.PageRequestManager) {
        const inst = sys.WebForms.PageRequestManager.getInstance();
        inst.add_pageLoaded(renderComponentsConditionally);
    }
};
const renderComponentsConditionally = () => {
    const indberetResultat = document.getElementById('v2-edit-match-results');
    if (indberetResultat) {
        ReactDOM.render(React.createElement(App, null), indberetResultat);
    }
};
if (process.env.API_URL === "local" && window.location.href.indexOf(":8080") !== -1) {
    loadLocalDevelopmentEnvironment();
}
else {
    loadServerEnvironment();
}
